import type { ns } from '@/i18n';
import type { Universe } from '@/services/domain';

/** A route title: a `title.*` key of the shell catalogue (src/i18n/shell), translated by the top bar. */
export type ShellTitle = Extract<keyof (typeof ns.shell)['catalogues']['fr'], `title.${string}`>;

/**
 * Per-route shell configuration, declared as the route `handle` in app/router.tsx.
 * It decides the universe colours, header and bars for the page.
 */
export interface ShellHandle {
  universe: Universe;
  /** Full-bleed hero: the header floats transparent over it until the page scrolls. */
  hero?: boolean;
  /**
   * Desktop header centre:
   * - `switch`: Véhicules / Expériences switch
   * - `switch-until-deep`: the switch, replaced by the search pill after 560 px of scroll (home)
   * - `pill`: the current vehicle search, opens the search sheet
   * - `secure`: «Paiement sécurisé · Stripe» (checkout and confirmations)
   * - `none`
   */
  center: 'switch' | 'switch-until-deep' | 'pill' | 'secure' | 'none';
  /** Mobile top bar: root pages show the logo; inner pages a back button and a title (or the search pill). */
  top: { kind: 'root'; switch?: boolean; title?: ShellTitle } | { kind: 'inner'; title?: ShellTitle; pill?: boolean };
  /** Active bottom-bar item. */
  tab?: 'explore' | 'favourites' | 'trips' | 'profile';
  /** The mobile bottom bar (default true). Pages with a sticky action bar hide it. */
  bottomNav?: boolean;
  /** Footer (default true). */
  footer?: boolean;
  /** Where «Retour» goes when there is no in-app history. */
  parent?: string;
}

export const DEFAULT_HANDLE: ShellHandle = { universe: 'veh', center: 'pill', top: { kind: 'inner' } };
